/* eslint react/prop-types: 0 */
import React from 'react';
import PropTypes from 'prop-types';

/**
 * Representation of a body in the Dialog.
 * @returns {React.ReactElement} ModalBody
 */
export default function ModalBody({ children }) {
  return <div className={ 'modal-body' }>{children}</div>;
}

ModalBody.propTypes = {
  /** Child elements */
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node
  ])
};
